var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showThumbnail
    ? _c(_setup.ImageSelection, {
        attrs: {
          "form-id": _vm.formId,
          "column-name": _vm.field.name,
          "file-browser": !_setup.isImage,
          "file-id": _setup.fileId,
          "on-change": _setup.onChange,
          "remove-option": false,
          "row-id": _vm.currentData.id,
          "table-name": _setup.tableName,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }